import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateAgentDto } from '../../dtos/create-agent.dto';
import { UpdateAgentDto } from '../../dtos/update-agent.dto';
import { createAgentSchema } from '../schemas/create-agent.schema';
import { updateAgentSchema } from '../schemas/update-agent.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
  record: CreateAgentDto | UpdateAgentDto,
  abortEarly = false,
): ValidationFunctionResult => {
  // Check
  if (!record) throw new Error('record is required.');

  let validationResult: ValidationResult | undefined;

  // TODO: Revise this check once front-end is able to use different
  // DTOs for create and update

  // Check if record has an id property with a value to determine if
  // it's an update or create operation
  if ('id' in record && record.id) {
    validationResult = updateAgentSchema().validate(record, {
      abortEarly,
    });
  } else {
    validationResult = createAgentSchema().validate(record, {
      abortEarly,
    });
  }

  // Check for validation errors
  if (validationResult?.error) {
    return {
      isValid: false,
      errors: validationResult.error.details?.map((e) => e.message),
    };
  }

  // Return
  return { isValid: true };
};
